import { compose, withHandlers } from "recompose";

import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

import { getTiersXtraData, setTiersXtraData } from "../../tools/tiersExtraData";

const notifications = withHandlers({
  sendSuccessCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = intl.formatMessage({
      id: "ids_collaboratorHasBeenCreated"
    });
    sendNotification(notif);
  },
  sendFailureCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_collaboratorCreateFailed_notification"
    });
    sendNotification(notif);
  },
  sendSuccessUpdateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = intl.formatMessage({
      id: "ids_collaboratorHasBeenUpdated"
    });
    sendNotification(notif);
  },
  sendFailureUpdateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_collaboratorUpdateFailed_notification"
    });
    sendNotification(notif);
  },
  sendFailureCheckMailNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_collaboratorCheckMailFailed_notification"
    });
    sendNotification(notif);
  }
});

const handlers = withHandlers({
  deleteCollaborators: () => async data => {
    alert("not implemented yet");
    console.log("deleteCollaborators", data);
    // await Promise.all(data.map(async (expense) => {
    //   deleteExpenseMutation(expense.id);
    // }));
  },
  createCollaborator: ({
    companyId,
    sendSuccessCreateNotification,
    sendFailureCreateNotification,
    sendFailureCheckMailNotification,
    createCollaboratorMutation,
    connectCollaboratorMutation,
    checkMailCollaboratorMutation,
    setNotifBankMutation
  }) => async values => {
    values["companyId"] = companyId;
    values["name"] = `${values["firstName"]} ${values["lastName"]}`;

    if (values.taxIdemCompany) {
      values["tax1Id"] = "";
      values["tax2Id"] = "";
    } else {
      values["tax1Id"] = values.tax1 && values.tax1.id;
      values["tax2Id"] = values.tax2 && values.tax2.id;
    }

    values["xtraData"] = setTiersXtraData(null, values.taxableValue, values.externalCodeValue, values.escomptePercentValue)

    // console.log("79 - CREATE Collaborator", values);    
    try {
      const checkMail = await checkMailCollaboratorMutation({ variables: values });

      if (checkMail && checkMail.data &&
        checkMail.data.checkMailCollaborator &&
        checkMail.data.checkMailCollaborator.result === true) {
        const mutation = await createCollaboratorMutation({
          variables: values,
          refetchQueries: [
            {
              query: Queries.GET_COLLABORATOR_CONNECTION,
              variables: {
                companyId: companyId,
                comptableOnly: false,
                skip: 0,
                first: 1000,
                tiersId: ""
              }
            },
            {
              query: Queries.getTierses,
              variables: {
                companyId: companyId,
                showCollaborators: true,
                skip: 0,
                first: 1000
              }
            },
          ]
        });

        console.log("75 - mutation=", mutation);
        if (mutation && mutation.data && mutation.data.createCollaborator) {
          if (!values.taxIdemCompany || !!values["collaboratorRespComId"]) {
            // tax connection
            values["id"] = mutation.data.createCollaborator.client.id;
            values["connectTax1"] = !!values.tax1;
            values["disconnectTax1"] = false;
            values["connectTax2"] = !!values.tax2;
            values["disconnectTax2"] = false;

            console.log("VALUES BEFORE COLLABORATOR CONNECT", values);
            const connected = await connectCollaboratorMutation({
              variables: values
            });
            console.log("AFTER COLLABORATOR CONNECT", connected);
          }

          const variables = {
            tiersId: mutation.data.createTiers.id,
            notifBankTransactions: values.notifBankTransactions,
            notifBankAlerts: values.notifBankAlerts
          }

          // console.log("97 - companyId=", companyId)
          const notifBank = setNotifBankMutation({
            variables,
            // refetchQueries: [
            //   {
            //     query: Queries.GET_COLLABORATOR_CONNECTION,
            //     variables: {
            //       companyId: companyId,
            //       comptableOnly: false,
            //       skip: 0,
            //       first: 1000,
            //       tiersId: ""
            //     }
            //   }
            // ]
          });
          console.log("83 - notifBank=", notifBank);
        }
        sendSuccessCreateNotification();
        return mutation;
      }
      else
        sendFailureCheckMailNotification();
    } catch (e) {
      console.log(e);
      sendFailureCreateNotification();
    }
  },
  updateCollaborator: ({
    companyId,
    updateCollaboratorMutation,
    connectCollaboratorMutation,
    checkMailCollaboratorMutation,
    sendSuccessUpdateNotification,
    sendFailureUpdateNotification,
    sendFailureCheckMailNotification
  }) => async values => 
  {
    console.log("VALUES BEFORE Collaborator UPDATE", values);
    values["currencyId"] = values["currency"];
    values["name"] = `${values["firstName"]} ${values["lastName"]}`;
    values["tax1Id"] = values.tax1 && values.tax1.id;
    values["tax2Id"] = values.tax2 && values.tax2.id;

    // console.log("178 - UPDATE Collaborator", values);
    
    try {
      const checkMail = await checkMailCollaboratorMutation({ variables: values });

      if (checkMail && checkMail.data &&
        checkMail.data.checkMailCollaborator &&
        checkMail.data.checkMailCollaborator.result === true) {
        const mutation = await updateCollaboratorMutation({
          variables: values,
          refetchQueries: [
            {
              query: Queries.GET_COLLABORATOR,
              variables: { id: values.id }
            },
            {
              query: Queries.getTierses,
              variables: {
                companyId: companyId,
                showCollaborators: true,
                skip: 0,
                first: 1000
              }
            },
            {
              query: Queries.GET_COLLABORATOR_CONNECTION,
              variables: {
                companyId: companyId,
                comptableOnly: false,
                skip: 0,
                first: 1000,
                tiersId: ""
              }
            }
          ]
        });
        console.log("112 - mutation=", mutation);

        values["id"] = mutation.data.updateCollaborator.id;
        await connectCollaboratorMutation({ variables: values });

        sendSuccessUpdateNotification();
        return mutation;
      }
      else
        sendFailureCheckMailNotification();
    } catch (e) {
      console.log(e);
      sendFailureUpdateNotification();
    }
  }
});

export default compose(
  injectIntl,
  graphql(Queries.CONNECT_COLLABORATOR_MUTATION, { 
    name: "connectCollaboratorMutation"
  }),
  graphql(Queries.CREATE_COLLABORATOR_MUTATION, {
    name: "createCollaboratorMutation"
  }),
  graphql(Queries.UPDATE_COLLABORATOR_MUTATION, {
    name: "updateCollaboratorMutation"
  }),
  graphql(Queries.CHECK_MAIL_COLLABORATOR_MUTATION, {
    name: "checkMailCollaboratorMutation"
  }),
  graphql(Queries.SET_NOTIF_BANK, {
    name: "setNotifBankMutation"
  }),
  notifications,
  handlers
);
